import axios from "axios";
import { environment } from './environment'
import { saveAs } from 'file-saver';
const endpoint = environment.serverUrl;


export async function install() {
    //console.log("shopurl=",window.location.search)
    const response = await axios.get(endpoint+'/api/auth/install' + window.location.search);
    if(response.data !== true && response.data !==false)
    {
        //console.log("auth url=",response.data);
        window.open(response.data,"_top");
    }
    else if(response.data === false)
    {
    }
}

export async function getPageImportHistory(storeUrl, pageNo, pageSize) {
    try {
        const response = await axios.get(endpoint + '/api/Page/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize);
        
        if (response.status === 200 && response != null) {
            return response.data;
        } else {
            throw new Error('Empty data');
        }
    } catch (error) {
        console.error(error);
        return null;
    }
}
